module.exports = __webpack_public_path__ + "img/SC7-Insurance_needs.d78ee670.png";